import React, { useState, useReducer, useEffect } from 'react';
import { IconButton, Button, Tabs, Tab } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import { addInRoomDiningItem, editInRoomDiningItem } from '../../../../../utils/ServicesAPIUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import { formDataValidate, VALID_INTEGER } from '../../../../../utils/formUtils';
import ImageUpload from '../../../../../shared/image-upload/ImageUpload';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import { useDispatch, useSelector } from 'react-redux';
import { getProcessedImages } from '../../../../../shared/image-upload/ImageProcessor';
import ItemCreateDetails from './Item-Create-Details';
import ItemCreateAddons from './Item-Create-Addons';
import ItemCreateCustomisation from './Item-Create-Customisation';
import ItemCreateUpsell from './Item-Create-Upsell';
import ItemCreateDiscount from './Item-Create-Discount';
import {
  IN_ROOM_DINING_ITEMS_ADDONS_GROUPED,
  IN_ROOM_DINING_ITEMS_ADDONS_INACTIVE,
  IN_ROOM_DINING_ITEMS_ADDONS_UNGROUPED,
  IN_ROOM_DINING_TYPE,
} from '../../../../../constants/InRoomDiningConst';
import { allHotelsSelector } from '../../../../property/propertySlice';
import { fetchAllInRoomDining, fetchAllInRoomDiningMenu } from '../../../servicesSlice';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const ItemsCreate = (props) => {
  const { selectedItem, hotelId, toggleDrawer, restaurantId, showLoader = () => {} } = props;
  const dispatch = useDispatch();
  const originalHotels = useSelector(allHotelsSelector);
  const [tabValue, setTabValue] = useState(0);
  const [rawImages, setRawImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [customisationError, setCustomisationError] = useState(false);
  const [addOnError, setAddOnError] = useState(false);
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [validLimit, setValidLimit] = useState(false);
  const [groupAddon, setGroupAddon] = useState([]);

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    type: {
      value: '',
      fieldName: 'Item Type',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    status: {
      value: true,
      fieldName: 'Active',
      errors: {},
      validations: [],
      tab: 0,
    },
    name: {
      value: '',
      fieldName: 'Item Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    code: {
      value: '',
      fieldName: 'Item Code',
      errors: {},
      validations: ['required', 'validAlphaNumeric'],
      tab: 0,
    },
    description: {
      value: '',
      fieldName: 'Description',
      errors: {},
      validations: [],
      tab: 0,
    },
    price: {
      value: '',
      fieldName: 'Item Price',
      errors: {},
      validations: ['required', 'positiveOnlyWithZero'],
      tab: 0,
    },
    ingredients: {
      value: '',
      fieldName: 'Ingredients',
      errors: {},
      validations: [],
      tab: 0,
    },
    allergens: {
      value: [],
      fieldName: 'Allergens',
      errors: {},
      validations: [],
      tab: 0,
    },
    tags: {
      value: [],
      fieldName: 'Tags',
      errors: {},
      validations: [],
      tab: 0,
    },
    customAttributes: {
      value: [],
      fieldName: 'Custom Attributes',
      errors: {},
      validations: [],
      tab: 0,
    },
    addonsStatus: {
      value: 'active',
      fieldName: 'Status',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    addonsLimitStatus: {
      value: 'active',
      fieldName: 'Status',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    addonsMaxLimit: {
      value: '',
      fieldName: 'Maximum selection Limit',
      errors: {},
      validations: ['required', 'positiveOnly', VALID_INTEGER],
      tab: 1,
    },
    addonsId: {
      value: [],
      fieldName: 'Add-on',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    groupedAddon: {
      value: [],
      fieldName: 'Grouped Add-on',
      errors: {},
      validations: [],
      tab: 1,
    },
    groupTitle: {
      value: '',
      fieldName: 'Group Title',
      errors: {},
      validations: ['required'],
      tab: -1,
    },
    groupAddonsMaxLimit: {
      value: '',
      fieldName: 'Maximum selection Limit',
      errors: {},
      validations: ['required', 'positiveOnly'],
      tab: -1,
    },
    groupAddonsId: {
      value: [],
      fieldName: 'Add-on',
      errors: {},
      validations: ['required'],
      tab: -1,
    },
    customisationStatus: {
      value: 'active',
      fieldName: 'Status',
      errors: {},
      validations: ['required'],
      tab: 2,
    },
    customisationIngredient: {
      value: '',
      fieldName: 'Ingredient Name',
      errors: {},
      validations: ['required'],
      tab: -1,
    },
    ingredientCustomisationId: {
      value: [],
      fieldName: 'Customisation Name',
      errors: {},
      validations: ['required'],
      tab: -1,
    },
    customisationArray: {
      value: [],
      fieldName: 'Customisation List',
      errors: {},
      validations: ['required'],
      tab: 2,
    },
    upsellStatus: {
      value: 'active',
      fieldName: 'Status',
      errors: {},
      validations: ['required'],
      tab: 3,
    },
    upsellItems: {
      value: [],
      fieldName: 'Upsell Items',
      errors: {},
      validations: ['required', 'maxLength'],
      maxLength: 5,
      tab: 3,
    },
    discountStatus: {
      value: 'active',
      fieldName: 'Status',
      errors: {},
      validations: ['required'],
      tab: 4,
    },
    discount: {
      value: '',
      fieldName: 'Discount Code',
      errors: {},
      validations: ['required'],
      tab: 4,
    },
    images: {
      value: [],
      fieldName: 'Images',
      errors: {},
      validations: [],
      tab: 5,
    },
  });

  useEffect(() => {
    if (selectedItem) {
      const currFields = { ...formData };
      currFields.type.value = selectedItem.type;
      currFields.status.value = selectedItem.status;
      currFields.name.value = selectedItem.name;
      currFields.code.value = selectedItem.code;
      currFields.description.value = selectedItem.description;
      currFields.price.value = selectedItem.price;
      currFields.ingredients.value = selectedItem.ingredients;
      currFields.allergens.value = selectedItem.allergens || [];
      currFields.tags.value = selectedItem.tags || [];
      currFields.addonsId.value = [];
      currFields.addonsId.validations = [];
      currFields.addonsLimitStatus.value = 'inactive';
      currFields.addonsMaxLimit.validations = [];
      currFields.groupedAddon.value = [];
      currFields.groupedAddon.validations = [];
      if (selectedItem.addons.type === IN_ROOM_DINING_ITEMS_ADDONS_UNGROUPED) {
        currFields.addonsStatus.value = 'active';
        currFields.addonsId.value = selectedItem.addons.addons;
        currFields.addonsId.validations = ['required'];
        if (selectedItem.addons.limit === true) {
          currFields.addonsLimitStatus.value = 'active';
          currFields.addonsMaxLimit.validations = ['required', 'positiveOnly'];
          currFields.addonsMaxLimit.value = selectedItem.addons.value;
        }
      } else if (selectedItem.addons.type === IN_ROOM_DINING_ITEMS_ADDONS_GROUPED) {
        currFields.addonsStatus.value = 'grouped';
        currFields.groupedAddon.value = selectedItem.addons.groupedAddon;
        currFields.groupedAddon.validations = ['required'];
      } else {
        currFields.addonsStatus.value = 'inactive';
      }
      if (selectedItem.customisation.status === true) {
        currFields.customisationStatus.value = 'active';
        currFields.customisationArray.value = selectedItem.customisation.ingredients;
        currFields.customisationArray.validations = ['required'];
      } else {
        currFields.customisationStatus.value = 'inactive';
        currFields.customisationArray.value = [];
        currFields.customisationArray.validations = [];
      }
      if (selectedItem.upsell.status === true) {
        currFields.upsellStatus.value = 'active';
        currFields.upsellItems.value = selectedItem.upsell.items;
        currFields.upsellItems.validations = ['required', 'maxLength'];
      } else {
        currFields.upsellStatus.value = 'inactive';
        currFields.upsellItems.value = [];
        currFields.upsellItems.validations = [];
      }
      if (selectedItem.discount.status === true) {
        currFields.discountStatus.value = 'active';
        currFields.discount.value = selectedItem.discount.discount;
        currFields.discount.validations = ['required'];
      } else {
        currFields.discountStatus.value = 'inactive';
        currFields.discount.value = '';
        currFields.discount.validations = [];
      }
      currFields.images.value = selectedItem.images || [];
      currFields.customAttributes.value = selectedItem.customAttributes || [];

      setFormData(currFields);
    }
  }, [selectedItem]);

  const validate = (tabValue) => {
    let customisationValidate = true;
    if (tabValue === 2 && formData.customisationStatus.value === 'active') {
      if (formData.customisationArray.value.length === 0) {
        customisationValidate = false;
        setCustomisationError(true);
      }
    }
    if (tabValue === 1 && formData.addonsStatus.value === 'grouped') {
      if (formData.groupedAddon.value.length === 0) {
        customisationValidate = false;
        setAddOnError(true);
      }
    }
    const updatedFields = {};
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, updatedFields);
    setFormData(updatedFields);
    if (tabValue === 1 && groupAddon.length > 0) {
      return true;
    }
    return isValid && customisationValidate;
  };

  const onImageListUpdated = (imgObjArr) => {
    setRawImages(imgObjArr);
  };

  const onUploadedImageRemoval = (index) => {
    const images = [...formData.images.value];
    images.splice(index, 1);
    setFormData({ images });
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  const handleTabChange = (event, newValue) => {
    if (newValue > tabValue) {
      if (validate(tabValue)) {
        if (tabValue == 1 && validLimit) {
          return;
        }
        setTabValue(newValue);
      }
    } else {
      setTabValue(newValue);
    }
  };

  const onNextClick = () => {
    if (validate(tabValue)) {
      setTabValue(tabValue + 1);
    }
  };

  const handleSubmit = async () => {
    if (validate(0) && validate(1) && validate(2) && validate(3) && validate(4) && validate(5)) {
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      const payload = {
        hotelId,
        restaurantId,
        type: formData.type.value,
        status: formData.status.value,
        name: formData.name.value,
        code: formData.code.value,
        price: formData.price.value,
        description: formData.description.value,
        ingredients: formData.ingredients.value,
        allergens: formData.allergens.value,
        tags: formData.tags.value,
        customAttributes: formData.customAttributes.value,
        addons: {},
        customisation: {},
        upsell: {},
        discount: {},
      };
      if (formData.addonsStatus.value === 'active') {
        payload.addons.type = IN_ROOM_DINING_ITEMS_ADDONS_UNGROUPED;
        payload.addons.addons = formData.addonsId.value;
        if (formData.addonsLimitStatus.value === 'active') {
          payload.addons.limit = true;
          payload.addons.value = formData.addonsMaxLimit.value;
        } else {
          payload.addons.limit = false;
        }
      } else if (formData.addonsStatus.value === 'grouped') {
        payload.addons.type = IN_ROOM_DINING_ITEMS_ADDONS_GROUPED;
        payload.addons.groupedAddon = formData.groupedAddon.value;
      } else {
        payload.addons.type = IN_ROOM_DINING_ITEMS_ADDONS_INACTIVE;
        payload.addons.limit = false;
      }
      if (formData.customisationStatus.value === 'active') {
        payload.customisation.status = true;
        payload.customisation.ingredients = formData.customisationArray.value;
      } else {
        payload.customisation.status = false;
        payload.customisation.ingredients = [];
      }
      if (formData.upsellStatus.value === 'active') {
        payload.upsell.status = true;
        payload.upsell.items = formData.upsellItems.value;
      } else {
        payload.upsell.status = false;
      }
      if (formData.discountStatus.value === 'active') {
        payload.discount.status = true;
        payload.discount.discount = formData.discount.value;
      } else {
        payload.discount.status = false;
      }

      try {
        dispatch(stepUpLoaderCount());
        toggleDrawer('', false, '');
        setLoading(true);
        payload.images = await getProcessedImages(
          rawImages,
          originalHotels.find((hotel) => hotel.id === hotelId).groupId,
          IN_ROOM_DINING_TYPE,
          hotelId,
        );
        if (selectedItem) {
          payload.id = selectedItem.id;
          await editInRoomDiningItem(payload, language);
          notificationManager('success', 'Item updated successfully');
        } else {
          await addInRoomDiningItem(payload, language);
          notificationManager('success', 'Item created successfully');
        }
        dispatch(fetchAllInRoomDining(hotelId, restaurantId));
        dispatch(fetchAllInRoomDiningMenu(hotelId, restaurantId));
      } catch (error) {
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          selectedItem
            ? notificationManager('danger', 'Failed to update Item')
            : notificationManager('danger', 'Failed to create Item');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
      setLoading(false);
    } else {
      notificationManager('danger', 'Enter all required fields');
      if (!validate(5)) {
        setTabValue(5);
      }
      if (!validate(4)) {
        setTabValue(4);
      }
      if (!validate(3)) {
        setTabValue(3);
      }
      if (!validate(2)) {
        setTabValue(2);
      }
      if (!validate(1)) {
        setTabValue(1);
      }
      if (!validate(0)) {
        setTabValue(0);
      }
    }
  };

  const onChangeRadioButton = (e, field) => {
    const tempField = formData[field];
    tempField.value = e.target.value;
    setFormData({ [field]: tempField });
  };

  useEffect(() => {
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, false);
    if (formData.addonsStatus.value === 'grouped' && tabValue === 1 && groupAddon.length > 0) {
      setIsTabInValid(false);
    } else {
      setIsTabInValid(!isValid);
    }
  }, [formData, tabValue]);

  return (
    <form className='category-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column'>
        <div className='d-flex fow px-3 w-100 mt-4'>
          <div className='col-md-2'>
            <span className='page-title'>{selectedItem ? 'Edit Item' : 'Add Item'}</span>
          </div>
          <div className='col-md-9'>
            <Tabs
              value={tabValue}
              variant='fullWidth'
              indicatorColor='primary'
              onChange={handleTabChange}
              aria-label='item-add-tabs'
              textColor='primary'
              className='property-tabs'
            >
              <Tab label='Details' />
              <Tab label='Add-ons' />
              <Tab label='Customisation' />
              <Tab label='Upsell' />
              <Tab label='Discounts' />
              <Tab label='Media' />
            </Tabs>
          </div>
          <div className='col-md-1 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
          {tabValue === 0 && (
            <ItemCreateDetails
              formData={formData}
              setFormData={setFormData}
              hotelId={hotelId}
              restaurantId={restaurantId}
            />
          )}
          {tabValue === 1 && (
            <ItemCreateAddons
              formData={formData}
              setFormData={setFormData}
              onChangeRadioButton={onChangeRadioButton}
              hotelId={hotelId}
              restaurantId={restaurantId}
              addOnError={addOnError}
              setAddOnError={setAddOnError}
              validLimit={validLimit}
              setValidLimit={setValidLimit}
              groupAddon={groupAddon}
              setGroupAddon={setGroupAddon}
            />
          )}
          {tabValue === 2 && (
            <ItemCreateCustomisation
              formData={formData}
              setFormData={setFormData}
              onChangeRadioButton={onChangeRadioButton}
              hotelId={hotelId}
              restaurantId={restaurantId}
              customisationError={customisationError}
              setCustomisationError={setCustomisationError}
              validate={validate}
            />
          )}
          {tabValue === 3 && (
            <ItemCreateUpsell
              formData={formData}
              setFormData={setFormData}
              onChangeRadioButton={onChangeRadioButton}
              hotelId={hotelId}
              selectedItemId={selectedItem?.id}
            />
          )}
          {tabValue === 4 && (
            <ItemCreateDiscount
              formData={formData}
              setFormData={setFormData}
              onChangeRadioButton={onChangeRadioButton}
            />
          )}
          {tabValue === 5 && (
            <div className='row px-3 w-100 d-flex mt-4'>
              <div className='col-md-12 mb-3'>
                <ImageUpload
                  uploadedImages={formData.images.value}
                  imgList={rawImages}
                  onImageListUpdated={onImageListUpdated}
                  onUploadedImageRemoval={onUploadedImageRemoval}
                  onImagesLoading={(status) => {
                    setLoading(status);
                  }}
                  enabledMediaTabs={['image']}
                />
              </div>
            </div>
          )}
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            {tabValue < 5 ? (
              <Button
                variant='contained'
                color='primary'
                onClick={onNextClick}
                size='large'
                className='me-3'
                disabled={isTabInValid || validLimit}
              >
                Next
              </Button>
            ) : (
              <Button
                disabled={loading}
                onClick={handleSubmit}
                variant='contained'
                color='primary'
                className='me-3'
                size='large'
              >
                {selectedItem ? 'Update' : 'Add'}
              </Button>
            )}
            <Button
              disabled={loading}
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
          {loading && <div className='pt-4 col-md-12'>{<LinearProgressBar />}</div>}
        </div>
      </div>
    </form>
  );
};

export default ItemsCreate;
